import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Accelerator } from '../../../interfaces/accelerator';
import { CurrentLesson } from '../../../interfaces/currentLesson';
import { Promo } from '../../../interfaces/promo';
import { clickFinishedtProductRecommendation, clickProduct, viewProduct } from '../../mixPanelEvents/mixPanelEvents';
import styles from './popUpDialogMobile.module.css';
import { Card, CardMedia, Grid, useMediaQuery, useTheme } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import parse from 'html-react-parser';


const mobileStyle = {
  position: 'absolute' as 'absolute',
  top: '20px',
  left: '50%',
  transform: 'translateX(-50%)',
  width: '90%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  overflow: 'visible',
};

type Props = {
  accelerator: Accelerator,
  currentLesson: CurrentLesson,
  accelName?: string,
  promo: Promo | null,
  callback?: (value: boolean) => void,
  source: string,
  completedCourse?: boolean,
  scratchClubPage?: boolean,
  showPop: boolean
};

export default function PopUpDialogMobile({
  accelerator,
  currentLesson,
  accelName,
  promo,
  callback,
  source,
  completedCourse,
  scratchClubPage = false,
  showPop
}: Props) {

  const [value1, setValue1] = React.useState(true);
  const modalBodyRef = React.useRef<HTMLDivElement>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))


  React.useEffect(() => {
    if (promo !== undefined && promo !== null) {
      viewProduct('Video', 'Pop Up', '', "In Video", promo.name);
    }
  }, []);



  return (
    <div>
      <Modal
        open={showPop}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflow: 'scroll' }}
      >
        <Box sx={mobileStyle}>
          <Box className={styles.modalHeader}>
            <img
              className={styles.modalCloseBtn}
              onClick={() => { if (callback) { callback(!value1) } }}
              src="https://members.performancegolf.com/wp-content/uploads/2025/04/closeIconchamionpass-2.png"
              alt="close"
            />
            <div className={styles.ribbon}>
              <span>RECOMMENDED FOR YOU</span>
            </div>
          </Box>
          <Box className={styles.modalContent}>
            <Box className={styles.modalBody} ref={modalBodyRef} sx={{ fontFamily: "Lato, sans-serif" }}>
              <Grid container padding={0} margin={0} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {promo?.promo_text &&
                  <Grid className={styles.gridTitlePopupModal} item lg={10} md={12} xs={12} padding={0} margin={0} sx={{ padding: "30px 0 0 0" }}>
                    <Typography className={styles.titlePopupModalTypo} sx={{ fontWeight: completedCourse ? 800 : 600, fontSize: completedCourse ? "25px" : "30px", textAlign: "center", lineHeight: completedCourse ? "28.75px" : "39px" }}>{promo?.promo_text}</Typography>
                  </Grid>
                }
                {!promo?.promo_text &&
                  <Grid className={styles.gridTitlePopupModal} item md={12} xs={12} padding={0} margin={0} sx={{ padding: "30px 0 0 0" }}>
                    <Typography sx={{ fontWeight: completedCourse ? 800 : 600, fontSize: completedCourse ? "25px" : "20px", whiteSpace: "nowrap", textAlign: "center", lineHeight: completedCourse ? "28.75px" : "26px" }}>{completedCourse ? "Congrats," : ""}</Typography>
                    <Typography sx={{ fontWeight: completedCourse ? 800 : 600, fontSize: completedCourse ? "25px" : "20px", whiteSpace: "nowrap", textAlign: "center", lineHeight: completedCourse ? "28.75px" : "26px" }}>{completedCourse ? "We See You Just Finished" : "We See That You Are Working on"}</Typography>
                    <Typography sx={{ fontWeight: completedCourse ? 800 : 600, fontSize: completedCourse ? "25px" : "20px", whiteSpace: "normal", textAlign: "center", lineHeight: completedCourse ? "28.75px" : "26px" }}>{accelName && !accelName?.includes("The") ? "The " + parse(accelName) : accelName && parse(accelName)} {scratchClubPage ? "Accelerator" : "Course"}</Typography>
                  </Grid>
                }
              </Grid>
              <Grid container padding={0} margin={0} sx={{ position: "relative", marginTop: { md: "30px", xs: 0 }, backgroundColor: 'rgba(255, 255, 255, 1)', display: 'flex', flexDirection: 'row', paddingBottom: "20px", alignItems: 'center' }}>
                <Grid item md={7} xs={12} padding={0} margin={0} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Card sx={{ maxHeight: "168px", maxWidth: "276px", borderRadius: "unset", border: "5px solid white", outline: "1px solid #E6E6E6", outlineOffset: "-1px" }} >
                    <CardMedia
                      sx={{ maxHeight: "168px", objectFit: "fill" }}
                      component="img"
                      alt="Random Course"
                      image={promo?.image}
                    />
                  </Card>
                </Grid>
                <Grid item md={6} xs={12} padding={0} margin={0} marginTop={isMobile? "10px":0} sx={{ display: 'flex', flexDirection: 'column', alignItems: {md:'center', xs:'unset'}, paddingLeft: { xs: "30px", md: 0 }, paddingRight: { xs: "30px", md: "40px" } }}>
                        <Grid item md={12} xs={12} padding={0} margin={0}>
                            <Typography sx={{fontWeight: 800, fontSize: "25px", lineHeight:"28.75px",mb:2}}>{promo?.name}</Typography>
                            <Typography sx={{fontWeight: 500, fontSize: "15px", lineHeight:"normal", mb: 2, letterSpacing: "-0.03px"}}>{promo?.course_desc? promo?.course_desc : promo?.promo_text}</Typography>
                        </Grid>
                        <Grid item md={12} xs={12} padding={0} margin={0} container>
                            <Button 
                                sx={{display: 'flex',alignItems: 'center',justifyContent: 'space-between'}} 
                                // sku: string, accelerator:Accelerator, lesson:Lesson, location:string
                                onClick={() => {completedCourse? clickFinishedtProductRecommendation("", accelerator, currentLesson, "Pop Up") : clickProduct(source === "player" ? "Video" : "Course Page", "Pop Up", "", promo?.ID, promo?.name, "In Video"); promo?  window.location.href = promo?.url: console.log("no url");}}
                            // { navigate(`${currentPromo?.url}`);}}
                                    className={styles.nextBtn} fullWidth>
                                <LockIcon sx={{color:"white"}} style={{ marginLeft: 0 }}></LockIcon>
                                <Typography sx={{fontWeight: 700, whiteSpace: "nowrap", flexGrow: 1, textAlign: 'center'}}>Unlock Now</Typography>
                            </Button>
                        </Grid>
                    </Grid>
              </Grid>
              <Button sx={{ margin: "7px auto", display: "block", textAlign: "center", textDecoration: "none", textTransform: 'none' }} onClick={() => {
                if (callback) {
                  callback(!value1)
                }
              }}>
                <Typography sx={{ fontWeight: 700, whiteSpace: "nowrap" }}>Close</Typography>
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}